export const environment = {
  url_api: 'https://api.tudociclismo.com.br/',
  url_site: 'https://tudociclismo.com.br',
  ga4MeasurementId: 'G-BD1D46VT0L'
};
